import WixPrintOnDemandBanner from './WixPrintOnDemandBanner'

export default WixPrintOnDemandBanner
